require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tapd-in-social-media-calendar-template.json") })
        }
      }, "path---tapd-in-social-media-calendar-template");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tapd-in-social-media-calendar-template!./.cache/json/tapd-in-social-media-calendar-template.json
// module id = 864
// module chunks = 231608221292675